import fetch from "lib/fetch";
import type { FileResponseInterface } from "types/file";

interface ListResponse<T> {
    data: Array<T>;
    pager: {
        total: number;
        total_page: number;
        last_page: number;
        per_page: number;
        current_page: number;
        order?: string;
        direction?: string;
        custom?: HashMap<number | undefined>;
    };
    filters: HashMap<unknown>;
}

export const getInvoicesRequest = (params?: HashMap<unknown>) =>
    fetch.get<ListResponse<unknown>>("invoice", { params });

export const downloadInvoiceRequest = (bookingId: string) =>
    fetch.get<{ data: FileResponseInterface }>(`invoice/${bookingId}/download`);
